import * as L from 'leaflet';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Subscription } from 'rxjs';
import { LocationPoint } from 'src/app/apiAndObjects/objects/observationSummary';
import { ResultItem } from 'src/app/apiAndObjects/objects/resultItems/resultItem.interface';
import { ResultItemType } from 'src/app/apiAndObjects/objects/resultItems/resultItemType.enum';
import { SearchResultItem } from 'src/app/apiAndObjects/objects/resultItems/searchResultItem';
import { ObservationsService } from 'src/app/services/observations.service';
import { EVPanelsService } from '../../services/panels.service';
import { EvLoadingComponent } from '../ev-loading/ev-loading.component';
import { EVMapService } from '../ev-map/ev-map.service';
import { EVResultsService } from './ev-sidebar-results.service';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-ev-sidebar-results',
  templateUrl: './ev-sidebar-results.component.html',
  styleUrls: ['./ev-sidebar-results.component.scss'],
  standalone: true,
  imports: [
    MatExpansionModule,
    MatIconModule,
    MatToolbarModule,
    EvLoadingComponent,
    CommonModule,
    MatCardModule,
    MatTableModule,
    MatChipsModule,
    MatBadgeModule,
    MatButtonModule,
  ],
})
export class EvSidebarResultsComponent {
  private readonly INITIAL_LIMIT = 20;
  private readonly LOAD_INCREMENT = 10;

  public volcanoName: any;
  public volcano: any;
  public empty = 'empty';
  public match = 'match';

  public readonly RESULT_TYPE_ENUM = ResultItemType;
  public subscriptions: Array<Subscription> = new Array<Subscription>();
  public resultItems = new Array<ResultItem>();

  public displayedColumns: string[] = ['name', 'value'];

  public loadLimit = this.INITIAL_LIMIT;
  public selectable = 'false';
  public imageArray = new Array<object>();
  imageResults: object[];

  constructor(
    private readonly resultsService: EVResultsService,
    private readonly panelsService: EVPanelsService,
    private readonly observationsService: ObservationsService,
    private readonly mapService: EVMapService,
  ) {
    this.subscriptions.push(
      this.resultsService.watchResults().subscribe((resultItems: Array<ResultItem>) => {
        if (resultItems.length === 0) {
          this.closeResultsPanel();
        } else {
          this.loadLimit = this.INITIAL_LIMIT;
          this.panelsService.setResultsPanelActive(true);

          const selectedOnlyPreviously = this.resultItems.every((item: ResultItem) => {
            return item instanceof SearchResultItem && item.summaryObject.isSelected;
          });
          if (this.resultItems.length > 0 && selectedOnlyPreviously) {
            // if there were select search results previously, panel stayed open and results changed,
            // so clear selected items flags.
            this.clearObservationSelectedFlags();
          }
        }
        // }
        this.resultItems = resultItems;
      }),
    );
  }

  public closeResultsPanel() {
    this.panelsService.setResultsPanelActive(false);
    this.clearObservationSelectedFlags();
    this.resultItems = [];
  }

  private clearObservationSelectedFlags(): void {
    this.observationsService.clearObservationSelectedFlags();
  }

  public loadMore(): void {
    this.loadLimit += this.LOAD_INCREMENT;
  }

  public goToLocation(location: LocationPoint) {
    const loc = new L.LatLng(location.lat, location.lon);
    this.mapService.zoomToLocation(loc);
  }
}
